import React, { Suspense, lazy } from 'react';
const SalesPage = lazy(() => import('./components/SalesPage').then(mod => ({
  default: mod.SalesPage
})));
export function App() {
  return <Suspense fallback={<div className="min-h-screen bg-[#0a0a0a] flex items-center justify-center" data-id="element-1">
          <div className="w-8 h-8 border-3 border-[#25D366] border-t-transparent rounded-full animate-spin" data-id="element-2" />
        </div>} data-id="element-0">
      <SalesPage data-id="element-3" />
    </Suspense>;
}